"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isKeyInObject = void 0;
/**
 * This check has 2 purposes:
 * a) to verify whether a key exists in an object.
 * b) to show TypeScript the key exists and can be used without any casts.
 *
 * @param obj
 * @param key
 */
var isKeyInObject = function (obj, key) { return key in obj; };
exports.isKeyInObject = isKeyInObject;
